<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Clients & Témoignages
        </h1>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 pb-40 header-text">
        <h1>Nos clients</h1>
        <p>
          Who are in extremely love with eco friendly system.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-user"></span>Expert Technicians</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-license"></span>Professional Service</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-phone"></span>Great Support</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-rocket"></span>Technical Skills</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-diamond"></span>Highly Recomended</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-service">
          <h4><span class="lnr lnr-bubble"></span>Positive Reviews</h4>
          <p>
            Usage of the Internet is becoming more common due to rapid advancement of technology and power.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End service Area -->

<!-- Start testimonial Area -->
<section class="testimonial-area section-gap" id="review">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="menu-content pb-60 col-lg-8">
        <div class="title text-center">
          <h1 class="mb-10">Témoignages clients</h1>
          <p>Who are in extremely love with eco friendly system.</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="margin: auto;">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner" style="padding-left: 30px; padding-right: 30px">
            <div class="carousel-item active">
              <div class="single-review">
                <img src="assets/img/r1.png" alt="">
                <div class="title d-flex flex-row">
                  <h4>lorem ipusm</h4>
                </div>
                <p>
                  Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker. Here
                  you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="single-review">
                <img src="assets/img/r1.png" alt="">
                <div class="title d-flex flex-row">
                  <h4>lorem ipusm</h4>
                </div>
                <p>
                  Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker. Here
                  you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="single-review">
                <img src="assets/img/r1.png" alt="">
                <div class="title d-flex flex-row">
                  <h4>lorem ipusm</h4>
                </div>
                <p>
                  Accessories Here you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker. Here
                  you can find the best computer accessory for your laptop, monitor, printer, scanner, speaker.
                </p>
              </div>
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" style="background: #3f3f8e; width: 25px;">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" style="background: #3f3f8e; width: 25px;">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End testimonial Area -->